import auth from '@/middleware/modules/auth'

const BusinessProfile = () => import(/* webpackChunkName: "_v-businessprofile" */ '@/views/instagram_analytics/BusinessProfile')
const BusinessProfileAnalytics = () =>
  import(/* webpackChunkName: "_v-businessprofile" */ '@/views/instagram_analytics/businessprofile/Analytics')
const BusinessProfileMedias = () =>
  import(/* webpackChunkName: "_v-businessprofile" */ '@/views/instagram_analytics/businessprofile/Medias')
export default [
  {
    path: 'instagram-analytics/business-profile/:id(\\d+)',
    name: 'businessprofile',
    component: BusinessProfile,
    redirect: { name: 'businessprofile-analytics' },

    meta: {
      layout: 'app-layout',
      middleware: [auth],
      breadcrumbs: ['iganalytics'],
    },
    children: [
      {
        path: 'analytics',
        name: 'businessprofile-analytics',
        props: (route) => ({ id: route.params.id }),
        component: BusinessProfileAnalytics,
        meta: {
          layout: 'app-layout',
          tab: 'analytics',
          middleware: [auth],
        },
      },
      {
        path: 'medias',
        name: 'businessprofile-medias',
        props: (route) => ({
          querySearch: route.query.search,
          id: route.params.id,
        }),
        component: BusinessProfileMedias,
        meta: {
          layout: 'app-layout',
          tab: 'medias',
          middleware: [auth],
        },
      },
    ],
  },
]
